import CustomSelect from "./custom-select.component";

export default CustomSelect;
